<div class="embed" *ngIf="!disableIframe">
	<iframe [src]="url" width="100%" height="100%" allowfullscreen="true" webkitallowfullscreen="true" mozallowfullscreen="true"></iframe>
</div>

<div class="" *ngIf="disableIframe">
	{{ 'player.zoom-us' | translate }}
</div>
